import AuthRoutes from './router';
import AuthActions from './actions';
import AuthInterceptor from './interceptor';
import AuthService from './service';
import LoginContainer from './login/login';
import SignupContainer from './signup/signup';
import ForgotPasswordContainer from './forgot-password/forgot-password';
import ResetPasswordContainer from './reset-password/reset-password';
import ActivateContainer from './activate/activate';
import InactiveContainer from './inactive/inactive';
import OtpActivateContainer from './otpActivation/otpactive';
import SubscriptionEmail from './subscription-email/subscription-email';
import subscriptionModify from './subscription-modify/subscription-modify';

export default angular.module('app.auth', [])
  .config(AuthRoutes)
  .value('authActions', AuthActions)
  .factory('authInterceptor', AuthInterceptor)
  .factory('authService', AuthService)
  .component('login', LoginContainer)
  .component('signup', SignupContainer)
  .component('forgotPassword', ForgotPasswordContainer)
  .component('resetPassword', ResetPasswordContainer)
  .component('activate', ActivateContainer)
  .component('inactive', InactiveContainer)
  .component('otpactivate', OtpActivateContainer)
  .component('subscriptionEmail', SubscriptionEmail)
  .component('subscriptionModify', subscriptionModify);




// WEBPACK FOOTER //
// ./src/app/auth/main.js